import { NgFor, NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnChanges } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { DsSelectComponent } from '@design-system/ds-select/component/ds-select.component';
import { DsTextComponent } from '@design-system/ds-text/component/ds-text.component';
import { BaseDropdownInterface } from '@interfaces/base-dropdown.interface';
import { compareDropdownById } from '../../../helpers/compare-dropdown-by-id.helper';
import { BlockTimeFactInterface } from '../../../interfaces/block-time-fact.interface';
import { BLOCK_TIME_ADD_MODE_SELECT_LABELS, BLOCK_TIME_FIELD_ERRORS } from '../../../properties/block-time-record-modal.properties';
import { BlockTimeDetailsFormGroup } from '../../../types/block-time-record-form.type';

/**
 * Shows the service request facts of a block time record.
 * In add mode, the user selects the trip, the customer, the air vendor and the tail number.
 */
@Component({
  selector: 'app-btr-service-request-details',
  templateUrl: './btr-service-request-details.component.html',
  styleUrls: ['./btr-service-request-details.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [NgIf, NgFor, ReactiveFormsModule, MatFormFieldModule, DsSelectComponent, DsTextComponent],
})
export class BtrServiceRequestDetailsComponent implements OnChanges {
  @Input() facts: BlockTimeFactInterface[] = [];
  @Input() isAddMode = false;
  @Input() group: BlockTimeDetailsFormGroup | null = null;
  @Input() tripOptions: BaseDropdownInterface[] = [];
  @Input() customerOptions: BaseDropdownInterface[] = [];
  @Input() airVendorOptions: BaseDropdownInterface[] = [];
  @Input() tailOptions: BaseDropdownInterface[] = [];
  /** The modal increments this value after an invalid save, so that this OnPush view shows the field errors. */
  @Input() validationRun = 0;
  @Input() isLoadingLists = false;
  @Input() isLoadingTails = false;

  readonly compareById = compareDropdownById;
  readonly fieldErrors = BLOCK_TIME_FIELD_ERRORS;

  visibleFacts: BlockTimeFactInterface[] = [];
  tripPlaceholder = 'Select trip';
  customerPlaceholder = 'Select customer';
  airVendorPlaceholder = 'Select air vendor';
  tailPlaceholder = 'Select tail number';

  ngOnChanges(): void {
    const loadingText = 'Loading…';

    this.tripPlaceholder = this.isLoadingLists ? loadingText : 'Select trip';
    this.customerPlaceholder = this.isLoadingLists ? loadingText : 'Select customer';
    this.airVendorPlaceholder = this.isLoadingLists ? loadingText : 'Select air vendor';
    this.tailPlaceholder = this.isLoadingTails ? loadingText : 'Select tail number';
    this.visibleFacts = this.isAddMode ? this.facts.filter((fact) => !BLOCK_TIME_ADD_MODE_SELECT_LABELS.includes(fact.label)) : this.facts;
  }

  trackByLabel(_index: number, fact: BlockTimeFactInterface): string {
    return fact.label;
  }
}
